import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	buildMergedRows,
	formatBrsrNumericCellValue,
	getCellDisplayVal,
	normKey,
	renderQuestionAnswer,
	renderType3TableAnswer
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple4 = ({
	t,
	page6,
	yearFilter
}) => {
	// Align with BRSRReportGenerator: template data lives under currentYear; fall back to flat page6 for legacy callers
	const page6Data = page6?.currentYear ?? page6;

	const renderTableAnswer = (qIndex, colNos) => {
		const d = page6Data || {};
		if (!d[QUES_CODE_PREFIX + qIndex] || d[QUES_CODE_PREFIX + qIndex].keyValues?.length === 0) return <tr></tr>;


		const block = d[QUES_CODE_PREFIX + qIndex];
		if (block?.keyValueType === 'TYPE_3_TABLE') {
			const type3 = renderType3TableAnswer(page6Data, qIndex, colNos);
			if (type3 != null) return type3;
		}
		const answers = d[QUES_CODE_PREFIX + qIndex].keyValues;
		const { rowKeys: rows, groupedDataByCell } = buildMergedRows(answers, qIndex, colNos);
		const targetColNorm = (colNo) => normKey(`${QUES_CODE_PREFIX}${qIndex}${colNo}`);
		return (
			<>
				{rows?.map((row, rIndex) => (
					<tr key={`page6Table-row-${qIndex}-${rIndex}-${row}`}>
						{colNos?.map((colNo, cIndex) => {
							if (colNo === '') return <td key={`page6Table-row-${qIndex}-${rIndex}-${cIndex}`}>{rIndex + 1}</td>;
							const colNorm = targetColNorm(colNo);
							const entry = groupedDataByCell[row]?.find(val => normKey(val.key) === colNorm);
							return (
								<td key={`page6Table-row-${qIndex}-${rIndex}-${cIndex}`}>
									{getCellDisplayVal(entry?.value)}
								</td>
							);
						})}
					</tr>
				))}
			</>
		);
	};

	const renderP4Q1 = () => {
		const answer = {};
		if (page6Data) {
			page6Data[QUES_CODE_PREFIX + 'P4-1']?.keyValues?.forEach(val => {
				answer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			renderQuestionAnswer('1. Describe the processes for identifying key stakeholder groups of the entity.', answer[QUES_CODE_PREFIX + 'P4-1a'] ?? '')
		);
	};

	const renderP4Q2 = () => {
		const answer = {};
		if (page6Data) {
			page6Data[QUES_CODE_PREFIX + 'P4-2']?.keyValues?.forEach(val => {
				answer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>2. List stakeholder groups identified as key for your entity and the frequency of  engagement with each stakeholder group.</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Stakeholder Group</th>
								<th>Whether identified as vulnerable & marginalized Group (Yes/No)</th>
								<th>Channels of communication (Email, SMS, Newspaper, Pamphlets, Advertisement, Community meeting, Notice Board, Website), Other</th>
								<th>Frequency of engagement (Annually / Half yearly/ Quarterly/ others - please specify)</th>
								<th>Purpose and scope of engagement including key topics and concerns raised during such engagement</th>
							</tr>
						</thead>
						<tbody>
							{renderTableAnswer('P4-2', ['a', 'b', 'c', 'd', 'e'])}
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP4LI1 = () => {
		const answer = {};
		if (page6Data) {
			page6Data[QUES_CODE_PREFIX + 'P4-LI1']?.keyValues?.forEach(val => {
				answer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			renderQuestionAnswer('1. Provide the processes for consultation between stakeholders and the Board on economic, environmental, and social topics or if consultation is delegated, how is feedback from such consultations provided to the Board.', answer[QUES_CODE_PREFIX + 'P4-LI1a'] ?? '')
		);
	};

	const renderP4LI2 = () => {
		const answer = {};
		if (page6Data) {
			page6Data[QUES_CODE_PREFIX + 'P4-LI2']?.keyValues?.forEach(val => {
				answer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			renderQuestionAnswer('2. Whether stakeholder consultation is used to support the identification and management of environmental, and social topics (Yes / No). If so, provide details of instances as to how the inputs received from stakeholders on these topics were incorporated into policies and activities of the entity.', answer[QUES_CODE_PREFIX + 'P4-LI2a'] ?? '')
		);
	};

	const renderP4LI3 = () => {
		const answer = {};
		if (page6Data) {
			page6Data[QUES_CODE_PREFIX + 'P4-LI3']?.keyValues?.forEach(val => {
				answer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			renderQuestionAnswer('3. Provide details of instances of engagement with, and actions taken to, address the concerns of vulnerable/ marginalized stakeholder groups', answer[QUES_CODE_PREFIX + 'P4-LI3a'] ?? '')
		);
	};

	return (
		<section id="PRINCIPLE_4" className="Main_Section PRINCIPLE_4">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head mb-3">
						<h5>PRINCIPLE 4: Businesses should respect the interests of and be responsive to all its stakeholders</h5>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Essential Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body ">
								<div className='brsr-list'>
									{renderP4Q1()}
									{renderP4Q2()}
								</div>
							</div>
						</section>
					</div>
					<div className="ETA_card_Section_sub mt-2 mb-2">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Leadership Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body ">
								<div className='brsr-list'>
									{renderP4LI1()}
									{renderP4LI2()}
									{renderP4LI3()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple4);
